import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { PaywallLock } from '../paywall-lock'
import { InconsistentPlanLock_OfferLockDataFragment } from './__generated__/inconsistent-plan-lock.graphql'
import { Content } from './content'
import styles from './inconsistent-plan-lock.module.scss'
import { ModalLock } from './modal-lock'

interface InconsistentPlanLockProps {
  offerLockData: InconsistentPlanLock_OfferLockDataFragment
}

export const InconsistentPlanLock = ({ offerLockData }: InconsistentPlanLockProps) => {
  const content = <Content offerLockData={offerLockData} />
  const { componentType } = useContext(BoxLockContext)
  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles.paywallInconsistentPlanLock}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockData={offerLockData}>{content}</ModalLock>
    default:
      return null
  }
}

InconsistentPlanLock.fragments = {
  offerLockData: gql`
    fragment InconsistentPlanLock_offerLockData on OfferLockData {
      ...InconsistentPlanLockContent_offerLockData
      ...InconsistentPlanLockModalLock_offerLockData
      ...PaywallLock_offerLockData
    }

    ${Content.fragments.offerLockData}
    ${ModalLock.fragments.offerLockData}
    ${PaywallLock.fragments.offerLockData}
  `,
}
